import { useEffect } from 'react';
import {
  useMapContext,
  useMarkersContext
} from 'entities/map';

import { Props } from '..';

import { EMPTY_ARRAY } from 'shared/constants';

export const useMapMarkerLayers = (layers: Props['layers'] = EMPTY_ARRAY) => {
  const { map } = useMapContext();
  const { initMarkers, updateLayers } = useMarkersContext();

  useEffect(() => {
    initMarkers(map);
  }, [initMarkers, map]);

  useEffect(() => {
    updateLayers(layers);
  }, [
    layers,
    updateLayers
  ]);
};

